import React from 'react';
import { useMutation } from '@apollo/client';
import SaveUserDataMutation from './SaveUserDataMutation';
import BiometricSettingsQuery from '../../BiometricSettings/Fetch/BiometricSettingsQuery';

interface ISaveUserDataConnectorApolloProps {
  children: ({
    saveUserData,
  }: {
    saveUserData: (variables: any) => Promise<any>;
  }) => React.ReactElement;
}

const SaveUserDataConnectorApollo: React.FC<ISaveUserDataConnectorApolloProps> = ({ children }) => {
  const [save] = useMutation(SaveUserDataMutation, {
    awaitRefetchQueries: true,
    refetchQueries: [
      {
        query: BiometricSettingsQuery,
      },
    ],
  });

  const saveUserData = async (variables: any) => {
    const response = await save({
      variables: { ...variables },
    });

    return response.data.me.saveUserData;
  };
  return children({ saveUserData });
};

export default SaveUserDataConnectorApollo;
